import InterfaceIcon from "components/Icons/InterfaceIcon";
import React from "react";
import { useLocation } from "react-router-dom";
import "../Styling/App.css";

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = React.useState(false);
  const [isMobileViewport, setIsMobileViewport] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const toggleVisibility = () => {
      const isMobile = window.innerWidth < 768;
      const scrollTop = Math.max(
        window.scrollY,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );
      const visibilityThreshold = isMobile ? 140 : 420;

      // Keep floating chrome away from the campaign's primary actions.
      const campaignActionVisible = [...document.querySelectorAll(".campaign-cta")].some((action) => {
        const rect = action.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
      });
      setIsMobileViewport(isMobile);
      setIsVisible(scrollTop > visibilityThreshold && !campaignActionVisible);
    };

    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    window.addEventListener("resize", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", toggleVisibility);
    };
  }, []);

  React.useEffect(() => {
    setIsVisible(false);
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    });
  };

  return (
    <button
      type="button"
      className={`scroll-to-top-button${isVisible ? " is-visible" : ""}${
        isMobileViewport ? " is-mobile" : ""
      }`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
    >
      <InterfaceIcon name="arrow-up" size="1.35rem" />
    </button>
  );
}

export default ScrollToTopButton;
